import { useTranslation } from 'react-i18next';
import {
  Button,
  Spinner,
  makeStyles,
  mergeClasses,
  tokens,
} from '@fluentui/react-components';
import { useIsMobile } from '../hooks/useIsMobile';

const useStyles = makeStyles({
  actions: {
    display: 'flex',
    gap: tokens.spacingHorizontalS,
    justifyContent: 'flex-end',
    paddingBottom: tokens.spacingVerticalL,
  },
  actionsStacked: {
    flexDirection: 'column-reverse',
  },
  fullWidth: {
    width: '100%',
  },
});

export type FormActionsProps = {
  disabled: boolean;
  submitting: boolean;
  submitLabel: string;
  onClose: () => void;
};

export const FormActions = ({
  disabled,
  submitting,
  submitLabel,
  onClose,
}: FormActionsProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const styles = useStyles();

  return (
    <div
      className={mergeClasses(
        styles.actions,
        isMobile && styles.actionsStacked
      )}
    >
      <Button
        appearance="secondary"
        type="button"
        onClick={onClose}
        disabled={disabled}
        className={isMobile ? styles.fullWidth : undefined}
      >
        {t('cancel', 'Cancel')}
      </Button>
      <Button
        appearance="primary"
        type="submit"
        icon={submitting ? <Spinner size="tiny" /> : undefined}
        disabled={disabled}
        className={isMobile ? styles.fullWidth : undefined}
      >
        {submitLabel}
      </Button>
    </div>
  );
};
